import React from 'react';
import { useDropzone } from 'react-dropzone';
import { useToasts } from 'react-toast-notifications';



const ImageUploader = ({ file, setFile }) => {
    const { addToast } = useToasts();

    const onDrop = async (acceptedFiles) => {
        try {
            const uploadedFile = acceptedFiles[0];
            setFile(uploadedFile);

        } catch (error) {
            addToast(error.message, { appearance: 'error', });
            console.error('Error uploading file to IPFS:', error);
        }
    };

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        multiple: false,
        accept: {
            'image/jpeg': [],
            'image/png': [],
            'image/svg+xml': [],
            'image/gif': [],
            'image/avif': [],
        }
    });
    return (
        <div {...getRootProps()}>
            <input {...getInputProps()} />
            {file ? (

                <div class="nft__item_wrap">
                    <a href="#sec">
                        <img src={URL.createObjectURL(file)} id="get_file_2" class="lazy nft__item_preview" alt="banner" />
                    </a>
                </div>


            ) : (
                <div class="nft__item_wrap">

                    <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>
                    <p id="file_name">PNG, JPG, GIF, WEBP or MP4. Max 200mb.</p>

                </div>
            )}
        </div >
    );
};

export default ImageUploader;
